import Toast from './toast.vue';
let toastObj = {
  install: function (Vue) {
    let NewToast = Vue.extend(Toast);
    let toast = new NewToast();
    toast.$mount(document.createElement("div"))
    document.body.appendChild(toast.$el);
    Vue.prototype.$myToast = toast;
  }
};
export default toastObj;



// WEBPACK FOOTER //
// ./src/components/toast/index.js